import Glide from "@glidejs/glide";

export default function() {

	// Functions
	// --------------------
	function init() {
		let sliders = [...document.querySelectorAll(".glide")];
		if (sliders.length > 0) {
			sliders.map((item) => {
				let slider = new Glide(item, {
					type: "slider",
					startAt: 0,
					perView: 1,
				});
	
				slider.mount();
			});
		}
	}
	
	// Events
	// --------------------
	init();
	
	document.addEventListener("swup:contentReplaced", () => {
		init();
	});
}
